module.exports = __webpack_public_path__ + "img/headshot-joel-crosby@2x.874bf13b.jpg";